import jsPDF from "jspdf";
import { apiUrl } from "../config/api";
import brand from "../brand";

export const getTodayIsoDate = () => new Date().toISOString().split("T")[0];

export const formatDate = (dateValue) =>
  new Intl.DateTimeFormat("en-IN", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  }).format(new Date(`${dateValue}T00:00:00`));

export const fetchResultImage = async (time, date = getTodayIsoDate(), isAdmin = false) => {
  const formData = new URLSearchParams();
  formData.append("date", date);
  formData.append("time", time);

  const response = await fetch(
    apiUrl(isAdmin ? "get-image-admin" : "get-image"),
    {
      method: "POST",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
      body: formData,
    }
  );

  if (!response.ok) {
    throw new Error(`Result request failed with ${response.status}`);
  }

  const data = await response.json();
  return data.image || null;
};

export const fetchResultHistory = async () => {
  const response = await fetch(apiUrl("old-data"));
  if (!response.ok) {
    throw new Error(`History request failed with ${response.status}`);
  }

  const data = await response.json();
  return Array.isArray(data.results) ? data.results : [];
};

const fetchBase64Image = async (imageUrl) => {
  const formData = new URLSearchParams();
  formData.append("imageUrl", imageUrl);

  const response = await fetch(apiUrl("get_image.php"), {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
    },
    body: formData,
  });

  if (!response.ok) {
    throw new Error("Failed to prepare the result image.");
  }

  const data = await response.json();
  if (!data.image) {
    throw new Error("No image data was returned.");
  }

  return data.image;
};

export const downloadResultPdf = async (imageUrl, drawLabel) => {
  if (!imageUrl) {
    throw new Error("No result image is available yet.");
  }

  const base64Img = await fetchBase64Image(imageUrl);
  const img = new Image();
  img.src = base64Img;

  await new Promise((resolve, reject) => {
    img.onload = resolve;
    img.onerror = reject;
  });

  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const scale = Math.min(pageWidth / img.width, pageHeight / img.height);
  doc.addImage(base64Img, "JPEG", 0, 0, img.width * scale, img.height * scale);
  doc.save(
    `${brand.shortName.toLowerCase().replace(/\s+/g, "-")}-${getTodayIsoDate()}-${drawLabel
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")}.pdf`
  );
};

export const shareResult = async ({ title, text, url }) => {
  const shareUrl = url || window.location.href;
  if (navigator.share) {
    await navigator.share({ title, text, url: shareUrl });
    return "shared";
  }

  const copyText = `${title}\n${text}\n${shareUrl}`;
  if (navigator.clipboard) {
    await navigator.clipboard.writeText(copyText);
    return "copied";
  }

  window.open(
    `https://wa.me/?text=${encodeURIComponent(`${text} ${shareUrl}`)}`,
    "_blank",
    "noopener,noreferrer"
  );
  return "opened";
};
